import React from "react";

import { JourneyChart } from "components/views/patientDetails/ui/journeyChart";

import step1 from "./assets/withdraw/step-1.svg";
import step2 from "./assets/withdraw/step-2.svg";
import step3 from "./assets/withdraw/step-3.svg";

export const WithdrawDeviceView: React.FC<{ actions: React.ReactElement }> = ({ actions }) => {
  return (
    <JourneyChart>
      <JourneyChart.Title>Collection Process</JourneyChart.Title>
      <JourneyChart.Steps>
        <JourneyChart.Step imgSrc={step1}>The patient will be notified of device withdrawal</JourneyChart.Step>
        <JourneyChart.Step imgSrc={step2}>Device will be collected by Entia within 7 days </JourneyChart.Step>
        <JourneyChart.Step imgSrc={step3}>Results remain on the Entia Liberty Patient List</JourneyChart.Step>
      </JourneyChart.Steps>
      <JourneyChart.Actions>{actions}</JourneyChart.Actions>
    </JourneyChart>
  );
};
